import { Icon } from '@chakra-ui/react'

export const MainIcon = () => (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M60 112C88.718 112 112 88.7638 112 60C112 31.2362 88.6154 8 60 8C31.2821 8 8.00003 31.2362 8.00003 60C8.00003 88.7638 31.2821 112 60 112Z"
            fill="#F6F6F6"
            stroke="#C3C3C3"
            strokeMiterlimit="10"
        />
        <path
            d="M100.803 91.5434H19.1974C15.4454 91.5434 12.3969 88.4949 12.3969 84.7429V32.4499C12.3969 28.6979 15.4454 25.6494 19.1974 25.6494H100.803C104.555 25.6494 107.603 28.6979 107.603 32.4499V84.9774C107.369 88.4949 104.32 91.5434 100.803 91.5434Z"
            fill="white"
            stroke="#C3C3C3"
            strokeMiterlimit="10"
        />
        <rect
            x="27.0224"
            y="28.0596"
            width="15.4764"
            height="5.19619"
            rx="2"
            fill="#F6F6F6"
            stroke="#C3C3C3"
            strokeMiterlimit="10"
        />
        <rect
            x="77.8563"
            y="28.0596"
            width="15.1214"
            height="5.19619"
            rx="2"
            fill="#F6F6F6"
            stroke="#C3C3C3"
            strokeMiterlimit="10"
        />
        <path
            d="M37.8071 16.2695H31.7237C30.6191 16.2695 29.7237 17.165 29.7237 18.2695V28.453C29.7237 29.5575 30.6191 30.453 31.7237 30.453H37.8071C38.9117 30.453 39.8071 29.5575 39.8071 28.453V18.2695C39.8071 17.165 38.9117 16.2695 37.8071 16.2695Z"
            fill="white"
            stroke="#C3C3C3"
            strokeMiterlimit="10"
        />
        <path
            d="M88.4635 16.2695H82.3801C81.2755 16.2695 80.3801 17.165 80.3801 18.2695V28.453C80.3801 29.5575 81.2755 30.453 82.3801 30.453H88.4635C89.5681 30.453 90.4635 29.5575 90.4635 28.453V18.2695C90.4635 17.165 89.5681 16.2695 88.4635 16.2695Z"
            fill="white"
            stroke="#C3C3C3"
            strokeMiterlimit="10"
        />
        <path
            d="M41.9437 60.5276C46.2175 60.5276 49.6821 57.063 49.6821 52.7892C49.6821 48.5154 46.2175 45.0508 41.9437 45.0508C37.6698 45.0508 34.2052 48.5154 34.2052 52.7892C34.2052 57.063 37.6698 60.5276 41.9437 60.5276Z"
            stroke="#9D9D9D"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M29.5153 73.194C29.5153 66.3936 35.1432 60.7656 41.9437 60.7656C48.7441 60.7656 54.3721 66.3936 54.3721 73.194"
            stroke="#9D9D9D"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M67.2694 51.3828H92.3607"
            stroke="#9D9D9D"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M67.2694 64.0449H77.1184"
            stroke="#9D9D9D"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M75.6415 95.3694C75.3145 96.7545 74.8241 98.221 74.252 99.4431C72.6991 102.458 70.2471 104.821 67.223 106.369C64.1172 107.917 60.4392 108.568 56.7612 107.754C48.0976 105.961 42.5397 97.4877 44.3379 88.8513C46.136 80.215 54.5544 74.5932 63.2181 76.4671C66.3239 77.1189 69.0211 78.6669 71.3096 80.7853C75.1511 84.6146 76.7857 90.155 75.6415 95.3694Z"
            fill="#C3C3C3"
            stroke="#959595"
            strokeMiterlimit="10"
        />
        <path
            d="M60.0002 85.4307C61.077 85.4308 61.8293 86.2996 61.8293 87.2598V90.2773H64.8469C65.807 90.2775 66.676 91.0296 66.676 92.1064C66.6759 93.1831 65.807 93.9354 64.8469 93.9355H61.8293V96.9531C61.8292 98.0298 60.9603 98.7821 60.0002 98.7822C58.9234 98.7822 58.1713 97.9133 58.1711 96.9531V93.9355H55.1535C54.6429 93.9355 54.179 93.754 53.842 93.417C53.5053 93.0801 53.3245 92.6168 53.3244 92.1064C53.3244 91.0295 54.1933 90.2773 55.1535 90.2773H58.1711V87.2598C58.1711 86.1829 59.04 85.4307 60.0002 85.4307Z"
            fill="white"
            stroke="#959595"
        />
    </svg>
)
